import { FC } from 'react';
import {
    Banner,
    BodyText,
    Button,
    Headline,
    Layout,
    Page,
    Stack,
} from '@servicetitan/design-system';
import { useParams } from 'react-router-dom';
import { ContentfulChannel, CONTENTFUL_CHANNELS_MAP } from '../utils/channels-redirects-data';

const getRedirectUrl = (channel: ContentfulChannel) => `${channel.url}?isPreview=true`;
export const ContentfulPreviewRouter: FC = () => {
    const { codeId } = useParams<{ codeId: string }>();
    const getRedirectHandler = (channel: ContentfulChannel) => () => {
        window.location.href = getRedirectUrl(channel);
    };
    const previewChannels = CONTENTFUL_CHANNELS_MAP.get(codeId);
    if (previewChannels?.length === 1) {
        window.location.href = getRedirectUrl(previewChannels[0]);
        return null;
    }
    const showError = !previewChannels?.length;
    return (
        <Page className="m-t-6 w-100">
            <Layout spacing="relaxed" type="island">
                <Layout.Section>
                    <Headline>Contentful Preview</Headline>
                    {showError ? (
                        <Banner className="m-t-2" title="Channel Error" status="critical">
                            <BodyText>
                                Something went wrong. Please contact Contentful system
                                administrator.
                            </BodyText>
                            <BodyText>{`Preview Code ID: ${codeId}`}</BodyText>
                        </Banner>
                    ) : (
                        <BodyText>
                            The contentful preview you selected has multiple channels. Please select
                            from the list below to be redirected:
                        </BodyText>
                    )}
                </Layout.Section>
                <Layout.Section>
                    <Stack direction="column" spacing={2}>
                        {previewChannels?.map(channel => (
                            <Button
                                primary
                                outline
                                key={channel.channelName}
                                onClick={getRedirectHandler(channel)}
                            >
                                {channel.channelName}
                            </Button>
                        ))}
                    </Stack>
                </Layout.Section>
            </Layout>
        </Page>
    );
};
ContentfulPreviewRouter.displayName = 'ContentfulPreviewRouter';
